export const GENRE_AND_CATEGORY_PATH = '/flashcards/:genreSlug/:categorySlug'
export const GENRE_PATH = '/flashcards/:genreSlug'
export const ALL_FLASHCARDS_PATH = '/flashcards'
